import { Box, Typography } from '@mui/material';

import LogoIcon from '../../svgs/LogoIcon';
import { FORTA_BLACK } from '../../../utils/colors';
import {
  FORTA_CONTACT_INFO,
  FORTA_CONTACT_INFO_STYLES,
  FORTA_CONTACT_INFO_TITLE_STYLES,
  FORTA_CONTACT_EMAIL_STYLES,
} from './constants';

function FortaContactInfo() {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1 }}>
        <LogoIcon color={FORTA_BLACK} width={56} height={56} />
        <Typography sx={FORTA_CONTACT_INFO_TITLE_STYLES}>Forta</Typography>
      </Box>
      <Box>
        <Typography sx={FORTA_CONTACT_INFO_STYLES}>{FORTA_CONTACT_INFO.address}</Typography>
        <Typography sx={FORTA_CONTACT_INFO_STYLES}>{FORTA_CONTACT_INFO.city}</Typography>
        <Typography sx={FORTA_CONTACT_INFO_STYLES}>Phone: {FORTA_CONTACT_INFO.phone}</Typography>
        <Typography sx={FORTA_CONTACT_EMAIL_STYLES}>{FORTA_CONTACT_INFO.email}</Typography>
      </Box>
    </Box>
  );
}

export default FortaContactInfo;
